module.exports = __webpack_public_path__ + "img/template.d9b59fc5.png";